/* Paths */
export const PATH_FORM = "/inicio";
export const PATH_COUPON = "/generar/cupon";
export const PATH_REQUEST = "/generar/Solicitud";
export const PATH_DETAIL = "/detalle";
export const PATH_API_HELI = "https://sandbox.helipagos.com";
export const PATH_BASE_URL = "https://api.tasas-catastro-test.relex.ar";
export const PATH_FRONT = "https://tasas-catastro-test.relex.ar/detalle?id=";
export const PATH_WEB_HOOK = "https://api.tasas-catastro-test.relex.ar/v1/payments/webhook";
